// extracted by mini-css-extract-plugin
module.exports = {"avatarWrapper":"championAvatar_avatarWrapper__1dZNX","avatarImage":"championAvatar_avatarImage__d7R0L","avatarName":"championAvatar_avatarName__FN_8c"};